import React from "react";
import { Popover } from "react-bootstrap";
import { useSelector } from "react-redux";

const ChemicalInfo = ({ chemicalId }) => {
  const chemicals = useSelector((state) => state.recipe.chemicals);
  const chemical = chemicals.find(
    (chemical) => chemical.chemicalId === chemicalId
  );

  if (!chemical) return null;
  return (
    <>
      <Popover.Header as="h3">{chemical.name}</Popover.Header>
      <Popover.Body>
        <small className="d-block">
          <strong>Manufacturer:</strong> {chemical.manufacturer}
        </small>
        <small className="d-block">
          <strong>Active Ingredients:</strong> {chemical.activeIngredients}
        </small>
        <small className="d-block">
          <strong>Brand Name:</strong> {chemical.brandName}
        </small>
      </Popover.Body>
    </>
  );
};

export default ChemicalInfo;
